import { Dayjs } from "dayjs";
import { datetime } from "../../../../util/library/datetime";

export const options: any = [
    { label: 'Vessel list', value: 'vessel' },
    { label: 'Requested list', value: 'request' },
];

export const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
};

type DisabledDate = (
    current: Dayjs,
    compare?: number | Dayjs
) => boolean;

export const disabledDate: DisabledDate = (
    current,
    compare = Date.now()
) => {
    return current && current < datetime(compare).endOf('day').value;
};

export enum ModeTabVesselPopup {
    List = 'available',
    Requests = 'requests'
}
